'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { subscribeFn } from 'eco-design-micro/apis/subscribeFn';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoEmail from 'eco-design/elements/eco-email';
import './index.scss';

const getLink = (text: string, link: string) => `<a href="${link}" target="_blank" rel="noopener noreferrer">${text}</a>`;
export const getEmailTermsTran = (locale: string, TermsOfUseLink: string, PrivacyPolicyLink: string) => {
    switch (locale) {
        case 'us':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        case 'ca':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        case 'de':
            return `Ich stimme zu, Newsletter und Marketing-E-Mails von EcoFlow zu erhalten. Weitere Informationen finden Sie in den ${getLink(
                'Nutzungsbedingungen',
                TermsOfUseLink,
            )} und der ${getLink('Datenschutzrichtlinie', PrivacyPolicyLink)}.`;
        case 'eu':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        case 'uk':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        case 'fr':
            return `J’accepte de recevoir les newsletters et e-mails marketing d’EcoFlow. Pour plus de détails, veuillez consulter les ${getLink(
                'Conditions d’utilisation',
                TermsOfUseLink,
            )} et la ${getLink('Politique de confidentialité', PrivacyPolicyLink)}. `;
        case 'es':
            return `Acepto recibir boletines y correos electrónicos de marketing de EcoFlow. Para más detalles, consulte los ${getLink(
                'Términos de uso',
                TermsOfUseLink,
            )} y la ${getLink('Política de privacidad', PrivacyPolicyLink)}.`;
        case 'it':
            return `Acconsento a ricevere newsletter e email di marketing da EcoFlow. Per maggiori dettagli, si prega di consultare i ${getLink(
                'Termini di utilizzo',
                TermsOfUseLink,
            )} e l’${getLink('Informativa sulla privacy', PrivacyPolicyLink)}.`;
        case 'nl':
            return `Ik ga akkoord met het ontvangen van nieuwsbrieven en marketing-e-mails van EcoFlow. Raadpleeg voor meer informatie de ${getLink(
                'Gebruiksvoorwaarden',
                TermsOfUseLink,
            )} en het ${getLink('Privacybeleid', PrivacyPolicyLink)}.`;
        case 'ph':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        case 'mx':
            return `Acepto recibir boletines informativos y correos electrónicos promocionales de EcoFlow. Para más detalles, consulta los ${getLink(
                'Términos de Uso',
                TermsOfUseLink,
            )} y la ${getLink('Política de Privacidad', PrivacyPolicyLink)}.`;
        case 'cn':
            return `我同意接收来自 EcoFlow 的资讯推送及营销邮件。详情请参阅 ${getLink('用户使用条款', TermsOfUseLink)} 与 ${getLink(
                '隐私政策',
                PrivacyPolicyLink,
            )}.`;
        case 'jp':
            return `EcoFlowの${getLink('プライバシーポリシー', TermsOfUseLink)}と${getLink('利用規約', PrivacyPolicyLink)}に同意する`;
        case 'za':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        case 'au':
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
        default:
            return `I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the ${getLink(
                'Terms of Use',
                TermsOfUseLink,
            )} and ${getLink('Privacy Policy', PrivacyPolicyLink)}.`;
    }
};

export default function Content({ id, data = {} }: ContentServerProps) {
    const { pc, h5, title, subTitle, emarsysType, isAgree = false, TermsOfUseLink = '', PrivacyPolicyLink = '' } = data;
    const { locale = 'us' } = getLocal();
    const prefixCls = 'index-join-email';

    const submitSubscribeHandle1 = ({ email }: any, callback: any) => {
        submitSubscribe(email, callback);
        return true;
    };
    const submitSubscribe = async (email: string, callback: any) => {
        const cookieDataA = subscribeCookie({
            entry_name: 'subscriptionfloating',
            entry_position: 0,
        });
        const res = await subscribeFn(email, emarsysType || 'WEB_REGISTER', locale, cookieDataA);
        if (res?.code === '0') {
            callback('success');
        } else {
            callback('fail');
        }
        return true;
    };
    return (
        <GloLayout className={`editor-index-join-email`} id={id} data={data} floorName="index-join-email">
            <div className={`eco-content-v2 ${prefixCls}-send-container`}>
                <div className={`${prefixCls}-send`}>
                    <div className={`${prefixCls}-send-l`}>
                        <div className={`${prefixCls}-send-title`}>{title}</div>
                        <div className={`${prefixCls}-send-desc`}>{subTitle}</div>
                    </div>
                    <div className={`${prefixCls}-send-r`}>
                        <EcoEmail
                            contactListId={[]}
                            tipsObj={{
                                placeholder: locale === 'us' ? 'Email' : undefined,
                            }}
                            termsHtml={getEmailTermsTran(locale, TermsOfUseLink, PrivacyPolicyLink)}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'click_subscribe',
                                button_name: 'Subscribe',
                                product_name: '',
                                module_name: title,
                            }}
                            defaultTermsCheck={isAgree}
                            key={`${isAgree}`}
                            onBeforeSendCallback={submitSubscribeHandle1}
                        />
                    </div>
                </div>
                <EcoImg className={`${prefixCls}-bg-img`} pc={pc} h5={h5} />
            </div>
        </GloLayout>
    );
}
